<template>
    <div>
        <div style="cursor: pointer" class="d-flex align-items-center">
            <font-awesome-icon :icon="!collapsed ? ['fa', 'plus'] : ['fa', 'minus']" class="arrow float-left mr-2"
                style="font-size: 20px" @click="collapsed = !collapsed"></font-awesome-icon>
            <h5 style="display: inline-block" class="d-inline-block mb-0" @click="collapsed = !collapsed">{{ title }}
            </h5>
            <CButton color="success" size="sm" class="filter-btn ml-auto" @click="applyFilterHandler"
                :disabled="!collapsed">
                Apply</CButton>
            <CButton color="danger" size="sm" class="filter-btn ml-1" @click="resetFilterHandler"
                :disabled="!collapsed || resetDisabled">
                Reset</CButton>
        </div>
        <CCollapse :show="collapsed" class="collapse-bar mt-3 pl-4" :duration="300">
            <div class="d-flex justify-between align-items-center">
                <CInput class="searchbar" placeholder="search" v-model.lazy="searchVal" :lazy="1000"
                    @keyup.enter="searchValue()" />
                <div v-if="!!searchVal" class="my-auto ml-3" style="cursor: pointer">
                    <font-awesome-icon :icon="['fas', 'times-circle']" @click="clearSearchField()" />
                </div>
                <!-- <div class="my-auto ml-3" style="cursor: pointer">
                    <font-awesome-icon :icon="['fa', 'search']"
                        @click="searchValue()" />
                </div> -->
            </div>
            <div class="mb-2 mt-3">
                <CLink @click="handleCheckAll"> Check All </CLink>
                |
                <CLink @click="handleUncheckAll"> Uncheck All </CLink>
            </div>

            <div class="collapse-bar-scroll">
                <div v-for="option in optionsWithChecked.filter(opt => (opt.name || '').trim().toLowerCase().indexOf(searchVal.trim().toLowerCase()) > -1)"
                    :key="option.id">
                    <CInputCheckbox :label="option.name" :value="option.name" :checked.sync="option.checked"
                        @update:checked="handleCheckboxUpdate" />
                </div>
            </div>
        </CCollapse>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        options: Array,
        collapsedProp: Boolean,
        resetDisabled: Boolean,
    },
    data() {
        return {
            collapsed: false,
            optionsWithChecked: [],
            searchVal: "",
        };
    },
    watch: {
        options() {
            this.optionsWithChecked = this.options.reduce((acc, opt, index) => {
                if (index > 0 && acc[acc.length - 1].name === opt.name) {
                    acc[acc.length - 1].id = acc[acc.length - 1].id + "," + opt.id;
                    return acc;
                }
                return [...acc, {
                    ...opt,
                    checked: opt.checked || false
                }];
            }, []);
        },
        collapsedProp() {
            this.collapsed = this.collapsedProp;
        }
    },
    computed: {
    },
    methods: {
        handleCheckAll() {
            this.optionsWithChecked.forEach((el) => {
                if ((el.name || "").trim().toLowerCase().indexOf(this.searchVal.trim().toLowerCase()) > -1) {
                    el.checked = true;
                }
            });
        },
        handleUncheckAll() {
            this.optionsWithChecked.forEach((el) => {
                if ((el.name || "").trim().toLowerCase().indexOf(this.searchVal.trim().toLowerCase()) > -1) {
                    el.checked = false;
                }
            });
        },
        applyFilterHandler() {
            const selectedCategories = this.optionsWithChecked.filter(opt => opt.checked);
            this.$emit("apply", selectedCategories);
        },
        resetFilterHandler() {
            this.handleUncheckAll();
            this.$emit("reset");
        },
        handleCheckboxUpdate() {

        },
        clearSearchField() {
            this.searchVal = "";
        }
    },
    beforeMount() {
    },
};
</script>

<style scoped>
.collapse-bar-scroll {
    max-height: 200px;
    overflow-y: scroll;
}

.collapse-bar input {
    width: 100%;
    margin-left: 4px;
}

.searchbar {
    width: 100%;
}
</style>
